/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "igniteui-react-core";
import { StringBuilder } from "igniteui-react-core";
import { stringIsNullOrEmpty } from "igniteui-react-core";
import { isNaN_ } from "igniteui-react-core";
/**
 * @hidden
 */
var LabelVisualModelExport = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(LabelVisualModelExport, _super);
    function LabelVisualModelExport() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.b = 0;
        _this.d = 0;
        _this.c = 0;
        _this.a = null;
        _this.u = null;
        _this.v = null;
        _this.w = null;
        _this.k = 0;
        _this.s = null;
        _this.t = null;
        _this.e = 0;
        _this.i = false;
        _this.g = false;
        _this.m = null;
        _this.n = null;
        _this.o = null;
        _this.l = null;
        _this.r = null;
        _this.h = false;
        _this.j = false;
        _this.f = false;
        _this.p = null;
        return _this;
    }
    LabelVisualModelExport.prototype.q = function () {
        var a = new StringBuilder(0);
        a.l("{");
        a.l("baseTheme : " + this.b + ", ");
        a.l("density : " + this.d + ", ");
        a.l("actualDensity : " + this.c + ", ");
        a.l("actualTextColor : " + this.a.serialize() + ", ");
        if (!stringIsNullOrEmpty(this.u)) {
            a.l("textStyleFontStyle : \"" + this.u + "\", ");
        }
        if (!stringIsNullOrEmpty(this.v)) {
            a.l("textStyleFontVariant : \"" + this.v + "\", ");
        }
        if (!stringIsNullOrEmpty(this.w)) {
            a.l("textStyleFontWeight : \"" + this.w + "\", ");
        }
        if (!stringIsNullOrEmpty(this.s)) {
            a.l("textStyleFontFamily : \"" + this.s + "\", ");
        }
        if (!stringIsNullOrEmpty(this.t)) {
            a.l("textStyleFontStretch : \"" + this.t + "\", ");
        }
        if (!isNaN_(this.k)) {
            a.l("textStyleFontSize : " + this.k + ", ");
        }
        a.l("shiftType : " + this.e + ", ");
        a.l("isShifted : " + this.i + ", ");
        a.l("isHighlighted : " + this.g + ", ");
        a.l("display : \"" + this.m + "\", ");
        a.l("flexDirection : \"" + this.n + "\", ");
        a.l("flexGrow : \"" + this.o + "\", ");
        a.l("alignItems :\"" + this.l + "\", ");
        a.l("text : \"" + this.r + "\", ");
        a.l("isHover : " + this.h + ", ");
        a.l("value : " + this.j + ", ");
        a.l("isDisabled : " + this.f + ", ");
        a.l("name : \"" + this.p + "\", ");
        a.l("}");
        return a.toString();
    };
    LabelVisualModelExport.$t = markType(LabelVisualModelExport, 'LabelVisualModelExport');
    return LabelVisualModelExport;
}(Base));
export { LabelVisualModelExport };
//# sourceMappingURL=LabelVisualModelExport.js.map
